import BrandSnippets from "../BrandSnippets/BrandSnippets";
import BrandThemes from "../BrandThemes/BrandThemes";
import Description from "../Description/Description";
import classes from './BrandInsights.module.css';

export default function BrandInsights({ entity, category , llm }) {
  return (
    <>
      <Description entity={entity} category={category} llm={llm}/>
      <div className={classes.brand}>
        <div className={classes.brand_specs}>
          <BrandSnippets entity={entity} category={category} llm={llm}  />
          <div className={classes.partition}></div>
          <BrandThemes entity={entity} category={category} llm={llm} />
        </div>
      </div>
    </>
  );
}
